import dayjs from 'dayjs';

export interface ISurfaceDevelopmentScheduleActivityDto {
  ScheduleId: number;
  ScheduleActivityId: number;
  Phase: string;
  Step: string;
  PhaseStepTypeId: number;
  SortOrder: number;
  Predecessor: string;
  Lag: string;
  PlannedDurationDays?: number | null;
  PlannedStart?: Date | null;
  PlannedFinish?: Date | null;
  ActualDurationDays?: number | null;
  ActualStart?: Date | null;
  ActualFinish?: Date | null;
}

export class SurfaceDevelopmentScheduleActivityDto implements ISurfaceDevelopmentScheduleActivityDto {
  ScheduleId: number;
  ScheduleActivityId: number;
  Phase: string;
  Step: string;
  PhaseStepTypeId: number;
  SortOrder: number;
  Predecessor: string;
  Lag: string;
  PlannedDurationDays?: number | null;
  PlannedStart?: Date | null;
  PlannedFinish?: Date | null;
  ActualDurationDays?: number | null;
  ActualStart?: Date | null;
  ActualFinish?: Date | null;
  Readonly?: Boolean;

  constructor(item: ISurfaceDevelopmentScheduleActivityDto) {
    this.ScheduleId = item.ScheduleId;
    this.ScheduleActivityId = item.ScheduleActivityId;
    this.Phase = item.Phase;
    this.Step = item.Step;
    this.PhaseStepTypeId = item.PhaseStepTypeId;
    this.SortOrder = item.SortOrder;
    this.Predecessor = item.Predecessor;
    this.Lag = item.Lag;
    this.PlannedDurationDays = item.PlannedDurationDays;
    this.PlannedStart = item.PlannedStart ? dayjs(item.PlannedStart).startOf('day').toDate() : null;
    this.PlannedFinish = item.PlannedFinish ? dayjs(item.PlannedFinish).startOf('day').toDate() : null;
    this.ActualDurationDays = item.ActualDurationDays;
    this.ActualStart = item.ActualStart ? dayjs(item.ActualStart).startOf('day').toDate() : null;
    this.ActualFinish = item.ActualFinish ? dayjs(item.ActualFinish).startOf('day').toDate() : null;
    const editable = this.Phase == 'CONSTRUCT';

    this.Readonly = !editable;
  }

}

export class SurfaceDevelopmentScheduleResetResponse {
  ScheduleActivities?: ISurfaceDevelopmentScheduleActivityDto[];
  UserEditedPhases?: string[];
  Message: string;
  ProjectId?: number;
  DrillGroupId?: number;
  Success: boolean;
}

export class SurfaceDevelopmentScheduleSaveResponse {
  Message: string;
  Success: boolean;
  Changes?: ISurfaceDevelopmentScheduleActivityDto[]
}